<template>
    <!-- POP UP FOR FINISH AND DID NOT SHOW -->
    <v-dialog v-model="show" max-width="400" content-class="popup">
        <v-card :color="colorType" dark>
            <v-card-title class="headline">
                {{ $t("message.PopupText") }}
            </v-card-title>
            <v-card-text></v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn id="yes-btn" @click="agree()" text>
                    {{ $t("message.ConfirmButton") }}
                </v-btn>
                <v-btn id="no-btn" @click.stop="show = false" text>
                    {{ $t("message.CancelButton") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: () => ({}),
    computed: {
        colorType() {
            const { type } = this.$store.state.Helpers.popup;
            switch (type) {
                case "finish":
                    return "success";
                case "didNotShow":
                    return "black";
                default:
                    return type && type.includes("delete") ? "error" : "";
            }
        },
        show: {
            get() {
                return this.$store.state.Helpers.popup.show;
            },
            set(value) {
                this.$store.state.Helpers.popup.show = value;
            },
        },
    },
    methods: {
        agree() {
            this.$store.dispatch(
                this.$store.state.Helpers.popup.type,
                this.$store.state.Helpers.popup.id
            );
            this.show = false;
        },
    },
    watch: {
        show(val) {
            if (val) {
                setTimeout(() => {
                    document.getElementById("yes-btn").focus();
                }, 0);
            }
        },
    },
};
</script>

<style>
.v-dialog.popup {
    border-radius: 14px;
}
</style>
